<!--
 * @Author: ldx
 * @Date: 2022-10-14 09:31:48
 * @LastEditors: ldx
 * @LastEditTime: 2023-03-29 17:22:12
 * @Description:  《安道研讨课堂用户帮助手册》
-->
<template>
  <CustomIframe :url="url"></CustomIframe>
</template>
<script>
import CustomIframe from '@/components/CustomIframe'
export default {
  components: {
    CustomIframe
  },
  data() {
    return {
      url: '/static/htmls/ytktsc.html'
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  height: calc(100% - 4px);

  // height: 100%;
  .iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
